<template>
  <div>
    <el-dialog :title="dialogTitle" top="50px" :visible.sync="dialogVisible" :close-on-click-modal="false" width="500px">
      <!-- 堆箱打卡照片截图 -->
      <div class="img-viewer" v-viewer="{movable: true}" v-if="type === 'img'">
        <div class="stack-week">第{{ planWeek }}周</div>
        <div class="stack-box" v-for="img in stackImgList" :key="img.imgUrl">
          <div class="stack-box-info">
            <div class="stack-info-name">{{ img.imgTitle }}</div>
            <div class="stack-info-status">{{ getImgResult(img.imgStatus) }}</div>
          </div>
          <div class="stack-box-img" @click="show">
            <img :src="getImg(img.imgUri)">
          </div>
        </div>
      </div>

      <div class="img-viewer" v-viewer="{movable: true}" v-if="type === 'perfect'">
        <div class="stack-week">第{{ planWeek }}{{isPerfect? '次': '周'}}</div>
        <div class="stack-box" v-for="img in stackImgList" :key="img.imgUrl">
          <div class="stack-box-info">
            <div class="stack-info-name">{{ img.perfectTaskTypeName }}标准照片</div>
            <div class="stack-info-status">{{ getImgResult(img.checkResult) }}</div>
          </div>
          <div class="stack-box-img" @click="show">
            <img :src="isPerfect? img.checkPhotoExtUrl : getImg(img.checkPhotoUri)">
          </div>
        </div>
      </div>

      <!-- 堆箱执行状态 -->
      <div v-if="type === 'status'" class="stack-status">
        <div class="status-btn">
          <div class="text-btn btn-last" @click="lastWeek" v-show="planWeek > 1">上一周</div>
          <div class="stack-week">第{{ planWeek }}周</div>
          <div class="text-btn btn-next" @click="nextWeek" v-show="planWeek < stackRecordList.length">下一周</div>
        </div>

        <div class="step">
          <div class="steps-row">
            <div v-for="(item, index) in stackStatusList" :key="index" class="step-pointer">
              <div class="status-name">{{ item.createUserName || '' }}</div>
              <div class="status-text">{{ item.planWeekStatusName || '' }}</div>
              <div class="status-time">{{ item.createDate | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="type === 'perfectStatus'" class="stack-status">
        <div class="status-btn">
          <div class="text-btn btn-last" @click="lastWeek" v-show="planWeek > 1">上一周</div>
          <div class="stack-week">第{{ planWeek }}周</div>
          <div class="text-btn btn-next" @click="nextWeek" v-show="planWeek < stackRecordList.length">下一周</div>
        </div>

        <div class="step">
          <div class="steps-row">
            <div v-for="(item, index) in stackStatusList" :key="index" class="step-pointer">
              <div class="status-name">{{ item.createUserName || '' }}</div>
              <div class="status-text">{{ item.planWeekStatusName || '' }}</div>
              <div class="status-time">{{ item.createDate | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="img-viewer" v-viewer="{movable: true}" v-if="type === 'lemon'">
        <div class="stack-week">第{{ stackInfo.planWeekName }}周</div>
        <div class="stack-box">
          <div class="stack-box-info">
            <div class="stack-info-name">青柠切割成8瓣照片</div>
          </div>
          <div class="stack-box-img" @click="show">
            <img :src="getImg(stackInfo.slicingPhotoUri)">
          </div>
        </div>
        <div class="stack-box">
          <div class="stack-box-info">
            <div class="stack-info-name">青柠1/2插瓶照片</div>
          </div>
          <div class="stack-box-img" @click="show">
            <img :src="getImg(stackInfo.bottlePhotoUri)">
          </div>
        </div>
        <div class="stack-box" v-if="stackInfo.cardPhotoUri">
          <div class="stack-box-info">
            <div class="stack-info-name">青柠仪式台卡执行照片</div>
          </div>
          <div class="stack-box-img" @click="show">
            <img :src="getImg(stackInfo.cardPhotoUri)">
          </div>
        </div>
        <div class="stack-box">
          <div class="stack-box-info">
            <div class="stack-info-name">科罗娜冰柜执行照片</div>
          </div>
          <div class="stack-box-img" @click="show">
            <img :src="getImg(stackInfo.coolerPhotoUri)">
          </div>
        </div>
        <!-- <div class="stack-box">
          <div class="stack-box-info">
            <div class="stack-info-name">青柠大行动照片</div>
          </div>
          <div class="stack-box-img" @click="show">
            <img :src="getImg(stackInfo.packetPhotoUri)">
          </div>
        </div> -->
      </div>

      <div v-if="type === 'lemonStatus'" class="stack-status">
        <div class="status-btn">
          <div class="text-btn btn-last" @click="lastWeek" v-show="planWeek > 1">上一周</div>
          <div class="stack-week">第{{ planWeek }}周</div>
          <div class="text-btn btn-next" @click="nextWeek" v-show="planWeek < stackRecordList.length">下一周</div>
        </div>
        <div class="step">
          <div class="steps-row">
            <div v-for="(item, index) in stackStatusList" :key="index" class="step-pointer">
              <div class="status-name">{{ item.createUserId || '' }}</div>
              <!-- <div class="status-text">{{ item.planWeekName || '' }}</div> -->
              <div class="status-time">{{ item.createTime | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
export default {
  name: 'order-step-info-dialog',
  props: {
    isPerfect: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      dialogTitle: '',
      planWeek: null,
      stackImgList: [],
      stackStatusList: [],
      stackRecordList: [],
      weekIndex: null,
      type: '',
      stackInfo: {}
    }
  },
  methods: {
    showDialog (info, type, index) {
      console.log(info)
      console.log(type)
      console.log(index)
      this.type = type
      this.dialogVisible = true
      if (type === 'perfect') {
        // 完美门店
        this.dialogTitle = '执行照片详情'
        this.planWeek = info.planWeek
        this.stackImgList = info.tradePerfectTrackTaskList
      } else if (type === 'img') {
        this.dialogTitle = '堆箱打卡照片详情'
        this.planWeek = info.planWeek
        this.stackImgList = []
        this.stackImgList.push(
          {
            imgTitle: '局部照片',
            imgUri: info.stackDetailFileUri,
            imgStatus: info.stackDetailCheckResult
          },
          {
            imgTitle: '全景照片',
            imgUri: info.stackFullFileUri,
            imgStatus: info.stackFullCheckResult
          },
          {
            imgTitle: '正面照片',
            imgUri: info.stackFrontFileUri,
            imgStatus: info.stackFrontCheckResult
          }
        )
      } else if (type === 'status') {
        this.dialogTitle = '堆箱执行状态详情'
        this.stackRecordList = info
        if (info.length) {
          this.weekIndex = info.length - 1
          this.planWeek = info[this.weekIndex].planWeek
          this.stackStatusList = info[this.weekIndex].weekStatusList
        }
      } else if (type === 'lemon') {
        this.dialogTitle = '执行照片详情'
        this.stackInfo = info
        this.planWeek = info.planWeek
        this.weekIndex = index
        this.stackStatusList = info[this.weekIndex]
      } else if (type === 'lemonStatus') {
        this.dialogTitle = '执行照片详情'
        this.stackRecordList = info
        this.weekIndex = index
        this.planWeek = info[this.weekIndex].planWeek
        this.stackStatusList = info
      } else {
        this.dialogTitle = '执行状态详情'
        this.stackRecordList = info
        this.weekIndex = index
        this.planWeek = info[this.weekIndex].planWeek
        this.stackStatusList = info[this.weekIndex].weekStatusList
      }
    },

    lastWeek () {
      this.weekIndex--
      this.planWeek = this.stackRecordList[this.weekIndex].planWeek
      this.stackStatusList = this.stackRecordList[this.weekIndex].weekStatusList
    },

    nextWeek () {
      this.weekIndex++
      this.planWeek = this.stackRecordList[this.weekIndex].planWeek
      this.stackStatusList = this.stackRecordList[this.weekIndex].weekStatusList
    },

    show () {
      const viewer = this.$el.querySelector('.img-viewer').$viewer
      viewer.show()
    },

    // 设置状态
    getImgResult (val) {
      if (val === 0) return '未通过'
      if (val === 1) return '通过'
      if (val === -1) return '结果暂未返回'
      if (val === -2) return '待人工审核'
      return '暂无'
    },

    getImg (uri) {
      return commonUtils.getImageUrl(uri)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__headerbtn {

  top: 15px;

  .el-dialog__close {
    font-size: 24px;
  }
}

.stack-week {
  font-weight: bold;
  text-align: center;
  font-size: $font-18;
  margin-bottom: 10px;
}

.img-viewer {
  max-height: 550px;
  overflow-y: auto;
}
.stack-box {
  margin-bottom: 20px;
  padding: 0 43px 0 45px;

  .stack-box-info {
    margin-bottom: 5px;

    display: flex;
    justify-content: space-between;

    .stack-info-name {
      font-weight: bold;
    }

    .stack-info-status {
      color: $base-red;
    }
  }

  .stack-box-img {
    width: 100%;
    height: 150px;
    text-align: center;

    img {
      height: 100%;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}

.stack-status {
  .status-btn {
    position: relative;
    padding-bottom: 10px;

    .text-btn {
      position: absolute;
      top: 5px;
    }

    .text-btn:hover {
      cursor: pointer;
      color: $base-red;
    }

    .btn-last {
      left: 40px;
    }

    .btn-next {
      right: 40px;
    }
  }

  .step {
    .status-name {
      text-align: right;
      width: 37%;
    }
    .status-text {
      font-size: $font-14 !important;
      top: -6px !important;
      left: calc(50% + 50px);
    }
    .status-time {
      font-size: $font-12 !important;
      top: 10px !important;
      color: #666 !important;
      left: calc(50% + 50px);
    }
  }
}
</style>
